/**
 * syncSearchParams - Met à jour l'URL avec `nextParams` UNIQUEMENT s'ils diffèrent
 * des paramètres courants. Évite un setSearchParams redondant au montage (qui changerait
 * la location.key, casserait la restauration de scroll et polluerait l'historique).
 *
 * Toujours en mode `replace` (raffinement de filtres = pas une nouvelle entrée d'historique).
 */
export function syncSearchParams(setSearchParams, currentSearchParams, nextParams) {
    const norm = (sp) => [...sp.entries()].sort().map(([k, v]) => `${k}=${v}`).join('&');
    if (norm(currentSearchParams) !== norm(nextParams)) {
        setSearchParams(nextParams, { replace: true });
    }
}
